import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Check, X, Star, FileText, Zap, BookOpen, ChevronRight, ShieldCheck, Gift } from 'lucide-react';
import { Accordion } from '../components/Accordion';
import { CountdownTimer } from '../components/CountdownTimer';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/1KfV3grZ1rB4bX28GxukAU/IMG_3649.png';
const CHECKOUT_LINK = 'https://checkout.ebookbtnlines.shop/cart/45448518336559:1';
const BONO_IMAGES = ['https://cdn.magicpatterns.com/uploads/wRCgLxJmKLxn55GTosxRyz/WhatsApp_Image_2026-06-09_at_13.14.41.jpg', 'https://cdn.magicpatterns.com/uploads/s1iuVgRdgNeah7P8jaTUYV/WhatsApp_Image_2026-06-09_at_13.14.43.jpg', 'https://cdn.magicpatterns.com/uploads/ufc6gczCFtSmjRyP2T4yRu/WhatsApp_Image_2026-06-09_at_13.14.42.jpg'];
export function LandingPage() {
  const scrollToBuy = () => {
    const el = document.getElementById('comprar');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const fadeInUp = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <div className="min-h-screen bg-zinc-950 text-zinc-100 selection:bg-pink-500/30" data-id="element-36">
      {/* HERO SECTION */}
      <section className="pt-10 pb-16 px-4 max-w-4xl mx-auto text-center" data-id="element-37">
        <motion.div initial="hidden" animate="visible" variants={fadeInUp} data-id="element-38">
          <div className="inline-block px-3 py-1 mb-4 rounded-full bg-pink-500/10 border border-pink-500/20 text-pink-400 text-sm font-medium tracking-wide uppercase" data-id="element-39">
            Exclusivo para jugadoras zurdas
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-4 leading-[1.1]" data-id="element-40">
            El primer manual de hockey pensado{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-pink-600" data-id="element-41">
              100% para tu zurda.
            </span>
          </h1>

          <div className="relative max-w-2xl mx-auto mb-4 cursor-pointer group" onClick={scrollToBuy} data-id="element-42">
            <div className="absolute inset-0 bg-pink-500/20 blur-3xl rounded-full opacity-50 group-hover:opacity-70 transition-opacity duration-500" data-id="element-43"></div>
            <img src={PRODUCT_IMAGE} alt="Hockey para Zurdas Manual" className="relative z-10 w-full h-auto drop-shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500" data-id="element-44" />
          </div>

          <p className="text-xl md:text-2xl text-zinc-300 font-medium mb-6 max-w-2xl mx-auto" data-id="element-45">
            "Lo que cambia cuando finalmente aprendés desde el lado correcto."
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-8 cursor-pointer" onClick={scrollToBuy} data-id="element-46">
            <Badge icon={<FileText size={16} data-id="element-48" />} text="100% PDF" data-id="element-47" />
            <Badge icon={<Zap size={16} data-id="element-50" />} text="Acceso Inmediato" data-id="element-49" />
            <Badge icon={<BookOpen size={16} data-id="element-52" />} text="6 Capítulos + 3 Bonos" data-id="element-51" />
            <Badge icon={<Star size={16} className="fill-current" data-id="element-54" />} text="4.8/5.0" data-id="element-53" />
          </div>

          <CTAButton onClick={scrollToBuy} data-id="element-55">QUIERO MI MANUAL AHORA</CTAButton>
        </motion.div>
      </section>

      {/* PAIN POINTS */}
      <section className="py-16 px-4 bg-zinc-900/30 border-y border-zinc-800/50" data-id="element-56">
        <div className="max-w-4xl mx-auto" data-id="element-57">
          <motion.h2 initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-58">
            Probablemente te haya pasado alguna de estas cosas 😬
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-59">
            {['Te enseñan técnicas pensadas para diestras y sentís que tenés que adaptar todo por tu cuenta.', 'Te sentís torpe al recibir la bocha de revés porque tu postura natural es diferente.', 'Te estancaste en tu nivel y sentís que por más que entrenes, no avanzás como querés.', 'Te comparás con tus compañeras diestras que parecen progresar mucho más rápido.', 'Perdés la confianza en los partidos importantes por miedo a equivocarte en la recepción.', 'No encontrás recursos, videos ni entrenadores que entiendan cómo potenciar tu zurda.'].map((point, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-zinc-900 border border-zinc-800 p-5 rounded-2xl flex gap-4 items-start" data-id="element-60">
                <div className="bg-pink-500/10 p-2 rounded-lg text-pink-500 mt-1" data-id="element-61">
                  <X size={20} data-id="element-62" />
                </div>
                <p className="text-zinc-300 leading-relaxed" data-id="element-63">{point}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* TEMARIO */}
      <section className="py-20 px-4 max-w-3xl mx-auto" data-id="element-64">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-66">
            ¿Qué vas a encontrar adentro?
          </h2>
          <p className="text-center text-zinc-400 mb-12" data-id="element-67">
            El paso a paso exacto para transformar tu juego.
          </p>

          <Accordion items={[{
          title: '🚀 CAPÍTULO 1 — DESCUBRÍ TU VERDADERO POTENCIAL',
          content: <BulletList items={['Por qué entrenás y no ves resultados', 'La frustración de sentirte siempre igual', 'El daño de compararte con otras jugadoras', 'El mito del talento natural', 'La mentalidad que tienen las jugadoras que progresan', 'Cómo desarrollar confianza real', 'Identificando tus bloqueos mentales', 'Construyendo una nueva identidad deportiva']} data-id="element-69" />
        }, {
          title: '⚠️ CAPÍTULO 2 — LOS ERRORES QUE NADIE TE CORRIGE',
          content: <BulletList items={['Por qué algunas jugadoras mejoran más rápido', 'Errores de postura', 'Errores de recepción', 'Errores de lectura de juego', 'Errores de toma de decisiones', 'La falsa sensación de progreso', 'Cómo analizar tus partidos', 'Diseñando un plan de corrección']} data-id="element-70" />
        }, {
          title: '🏑 CAPÍTULO 3 — DOMINIO TOTAL DE LA BOCHA',
          content: <BulletList items={['La base del control', 'Posición corporal eficiente', 'Recepciones perfectas', 'Control bajo presión', 'Control en velocidad', 'Protección de bocha', 'Errores frecuentes en jugadoras zurdas', 'Plan de mejora técnica de 30 días']} data-id="element-71" />
        }, {
          title: '🧠 CAPÍTULO 4 — LA CONFIANZA DE COMPETIR',
          content: <BulletList items={['Por qué te bloqueás cuando más importa', 'El miedo al error', 'La ansiedad competitiva', 'Cómo recuperar la confianza después de fallar', 'Concentración durante el partido', 'Control emocional', 'Rutinas mentales de alto rendimiento', 'Cómo competir con seguridad']} data-id="element-72" />
        }, {
          title: '📈 CAPÍTULO 5 — ENTRENAR PARA DESTACAR',
          content: <BulletList items={['La diferencia entre entrenar y mejorar', 'El entrenamiento deliberado', 'Cómo diseñar sesiones efectivas', 'Cómo medir el progreso', 'Cómo salir del estancamiento', 'La importancia del descanso', 'Hábitos de jugadoras exitosas', 'Tu sistema de mejora continua']} data-id="element-73" />
        }, {
          title: '👑 CAPÍTULO 6 — DE JUGADORA ESTANCADA A REFERENTE',
          content: <BulletList items={['Cómo piensan las jugadoras referentes', 'Construir liderazgo dentro del equipo', 'Comunicación efectiva', 'Manejo de conflictos', 'Superar derrotas', 'Construir una carrera deportiva sostenible', 'Mantener la motivación durante años', 'Diseñar tu legado deportivo']} data-id="element-74" />
        }]} data-id="element-68" />

          <div className="mt-12 text-center" data-id="element-75">
            <CTAButton onClick={scrollToBuy} data-id="element-76">
              ACCEDER AL TEMARIO COMPLETO
            </CTAButton>
          </div>
        </motion.div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-20 px-4 bg-zinc-900/30 border-y border-zinc-800/50" data-id="element-77">
        <div className="max-w-6xl mx-auto" data-id="element-78">
          <motion.h2 initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-79">
            Lo que dicen otras jugadoras zurdas
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-80">
            {[{
            name: 'Sofía',
            city: 'Rosario',
            text: 'Siempre sentí que jugaba en desventaja hasta que leí el manual. Mi control de bocha cambió por completo. ¡Recomendadísimo!'
          }, {
            name: 'Camila',
            city: 'Córdoba',
            text: 'Por fin alguien piensa en nosotras las zurdas. Los ejercicios son súper prácticos y fáciles de aplicar en los entrenamientos.'
          }, {
            name: 'Martina',
            city: 'La Plata',
            text: 'Me ayudó muchísimo con la confianza. Antes me bloqueaba en los partidos, ahora entro a la cancha súper segura de lo que hago.'
          }, {
            name: 'Valentina',
            city: 'Mendoza',
            text: 'El capítulo de dominio de bocha vale cada centavo. Mi entrenadora me preguntó qué estuve haciendo diferente estas semanas.'
          }, {
            name: 'Lucía',
            city: 'Buenos Aires',
            text: 'Es el recurso que estuve buscando por años. Si sos zurda, no lo dudes, te cambia la forma de ver el juego por completo.'
          }].map((t, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className={`bg-zinc-900 border border-zinc-800 p-6 rounded-2xl ${i === 3 ? 'md:col-span-1 lg:col-start-2' : ''} ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-81">
                <div className="flex text-pink-500 mb-4" data-id="element-82">
                  {[...Array(5)].map((_, j) => <Star key={j} size={16} className="fill-current" data-id="element-83" />)}
                </div>
                <p className="text-zinc-300 italic mb-6" data-id="element-84">"{t.text}"</p>
                <div className="flex items-center gap-3" data-id="element-85">
                  <div className="w-10 h-10 bg-zinc-800 rounded-full flex items-center justify-center text-zinc-500 font-bold" data-id="element-86">
                    {t.name[0]}
                  </div>
                  <div data-id="element-87">
                    <p className="font-semibold text-zinc-100" data-id="element-88">{t.name}</p>
                    <p className="text-xs text-zinc-500" data-id="element-89">{t.city}, Argentina</p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* COMPARISON (compact, below testimonials) */}
      <section className="py-16 px-4 max-w-5xl mx-auto" data-id="element-90">
        <motion.h2 initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-91">
          La diferencia es clara
        </motion.h2>

        <div className="grid grid-cols-2 gap-3 md:gap-5" data-id="element-92">
          {/* SIN */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-4 md:p-6" data-id="element-93">
            <div className="text-center mb-4 pb-3 border-b border-zinc-800" data-id="element-94">
              <h3 className="text-base md:text-xl font-bold text-zinc-400" data-id="element-95">
                SIN el manual
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-96">
              {['Entrenás con técnicas pensadas para diestras.', 'Te estancás sin entender qué estás haciendo mal.', 'Dudás de cada movimiento en la cancha.', 'Dependés de que tu entrenadora adapte los ejercicios.', 'Frustración constante al no ver resultados.', 'Mentalidad frágil ante el primer error.'].map((text, i) => <li key={i} className="flex gap-2 items-start text-zinc-400 text-sm md:text-base" data-id="element-97">
                  <X className="text-zinc-600 flex-shrink-0 mt-0.5" size={18} data-id="element-98" />
                  <span data-id="element-99">{text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* CON */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-pink-950/40 to-zinc-900 border border-pink-500/30 rounded-2xl p-4 md:p-6 relative overflow-hidden shadow-[0_0_30px_rgba(236,72,153,0.1)]" data-id="element-100">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-pink-400 to-pink-600" data-id="element-101"></div>
            <div className="text-center mb-4 pb-3 border-b border-pink-500/20" data-id="element-102">
              <h3 className="text-base md:text-xl font-bold text-pink-400" data-id="element-103">
                CON el manual
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-104">
              {['Técnica específica y optimizada para tu zurda.', 'Plan claro de mejora paso a paso.', 'Confianza total en tus recepciones y pases.', 'Autonomía para corregir tus propios errores.', 'Progreso visible y constante en cada entrenamiento.', 'Mentalidad inquebrantable de alto rendimiento.'].map((text, i) => <li key={i} className="flex gap-2 items-start text-zinc-100 font-medium text-sm md:text-base" data-id="element-105">
                  <Check className="text-pink-500 flex-shrink-0 mt-0.5" size={18} data-id="element-106" />
                  <span data-id="element-107">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="mt-8 text-center" data-id="element-108">
          <CTAButton onClick={scrollToBuy} data-id="element-109">QUIERO ESTOS RESULTADOS</CTAButton>
        </div>
      </section>

      {/* BONOS (own section, before the final offer) */}
      <section className="py-16 px-4 max-w-3xl mx-auto" data-id="element-110">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} data-id="element-111">
          <div className="text-center mb-8" data-id="element-112">
            <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-113">
              Tus bonos de regalo
            </h2>
            <p className="text-pink-400 font-semibold uppercase tracking-wider text-sm" data-id="element-114">
              <Gift className="inline-block w-4 h-4 mr-1 -mt-1" data-id="element-115" />
              Bonos gratis solo por hoy
            </p>
          </div>

          <Accordion items={[{
          title: <BonoTitle image={BONO_IMAGES[0]} text="BONO #1 — LOS 50 ERRORES QUE MANTIENEN ESTANCADAS A LAS JUGADORAS DE HOCKEY" data-id="element-117" />,
          content: <BulletList items={['Errores mentales', 'Errores técnicos', 'Errores en partidos', 'Errores de entrenamiento', 'Plan de corrección paso a paso']} data-id="element-118" />
        }, {
          title: <BonoTitle image={BONO_IMAGES[1]} text="BONO #2 — PLAN DE TRANSFORMACIÓN DE 90 DÍAS" data-id="element-119" />,
          content: <BulletList items={['Objetivos semanales', 'Sistema de seguimiento', 'Checklists de progreso', 'Plan de mejora gradual', 'Método de implementación']} data-id="element-120" />
        }, {
          title: <BonoTitle image={BONO_IMAGES[2]} text="BONO #3 — MANUAL DE CONFIANZA PARA PARTIDOS IMPORTANTES" data-id="element-121" />,
          content: <BulletList items={['Cómo controlar los nervios', 'Qué hacer después de equivocarte', 'Rutinas prepartido', 'Rutinas durante el partido', 'Rutinas postpartido', 'Sistema de confianza competitiva']} data-id="element-122" />
        }]} data-id="element-116" />

          <div className="mt-10 text-center" data-id="element-123">
            <CTAButton onClick={scrollToBuy} data-id="element-124">LOS QUIERO GRATIS HOY</CTAButton>
          </div>
        </motion.div>
      </section>

      {/* QUOTE (below bonos, above final offer) */}
      <section className="py-20 px-4 bg-pink-600 text-white text-center relative overflow-hidden" data-id="element-125">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10 mix-blend-overlay" data-id="element-126"></div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto relative z-10" data-id="element-127">
          <h2 className="text-3xl md:text-5xl font-black leading-tight tracking-tight" data-id="element-128">
            "Tu entrenadora no va a cambiar cómo enseña.
            <br className="hidden md:block" data-id="element-129" /> Pero vos podés cambiar cómo
            aprendés."
          </h2>
        </motion.div>
      </section>

      {/* FINAL OFFER SECTION */}
      <section id="comprar" className="py-20 px-4 bg-zinc-950 relative overflow-hidden" data-id="element-130">
        {/* ambient glow */}
        <div aria-hidden="true" className="absolute -top-24 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] bg-pink-600/10 blur-[120px] rounded-full pointer-events-none" data-id="element-131"></div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-lg mx-auto relative z-10" data-id="element-132">
          <div className="relative bg-zinc-900/80 backdrop-blur-sm border border-pink-500/30 rounded-3xl overflow-hidden shadow-[0_20px_60px_-15px_rgba(236,72,153,0.25)]" data-id="element-133">
            {/* top accent */}
            <div className="h-1.5 w-full bg-gradient-to-r from-pink-400 via-pink-500 to-pink-600" data-id="element-134"></div>

            {/* Header */}
            <div className="px-7 pt-8 pb-6 text-center border-b border-zinc-800/80" data-id="element-135">
              <span className="inline-flex items-center gap-1.5 bg-pink-500/10 text-pink-400 text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider mb-4" data-id="element-136">
                <Zap size={13} className="fill-current" data-id="element-137" />
                Oferta por tiempo limitado
              </span>
              <h2 className="text-2xl md:text-3xl font-extrabold leading-tight" data-id="element-138">
                Llevate el sistema completo hoy
              </h2>
              <p className="text-zinc-400 text-sm mt-2" data-id="element-139">
                Acceso inmediato + tus 3 bonos de regalo
              </p>
            </div>

            {/* Value stack */}
            <div className="px-7 py-6 space-y-3" data-id="element-140">
              {[{
              icon: '📚',
              text: '6 Tomos Principales'
            }, {
              icon: '🎁',
              text: '3 Bonos Exclusivos'
            }, {
              icon: '📖',
              text: 'Más de 450 páginas de contenido práctico'
            }, {
              icon: '🏑',
              text: 'Especialmente diseñado para jugadoras de hockey zurdas'
            }, {
              icon: '🧠',
              text: 'Mentalidad, confianza y rendimiento'
            }, {
              icon: '💪',
              text: 'Aplicable a cualquier nivel de juego'
            }].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-141">
                  <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-zinc-800/80 flex items-center justify-center text-base" data-id="element-142">
                    {item.icon}
                  </span>
                  <span className="text-zinc-200 text-sm md:text-base font-medium" data-id="element-143">
                    {item.text}
                  </span>
                  <Check size={16} className="text-pink-500 ml-auto flex-shrink-0" data-id="element-144" />
                </div>)}
            </div>

            {/* Countdown */}
            <div className="px-7 pb-2" data-id="element-145">
              <p className="text-center text-xs uppercase tracking-wider text-zinc-500 font-semibold mb-1" data-id="element-146">
                La oferta termina en
              </p>
              <CountdownTimer data-id="element-147" />
            </div>

            {/* Price + CTA */}
            <div className="px-7 pb-8 pt-2 text-center" data-id="element-148">
              <div className="flex items-end justify-center gap-3 mb-1" data-id="element-149">
                <span className="text-zinc-500 line-through text-2xl font-semibold" data-id="element-150">
                  $55.900
                </span>
                <span className="text-5xl md:text-6xl font-black text-white tracking-tight" data-id="element-151">
                  $19.990
                </span>
              </div>
              <p className="text-pink-400 text-sm font-semibold mb-6" data-id="element-152">
                Ahorrás más de un 64% solo por hoy
              </p>

              <a href={CHECKOUT_LINK} className="group block w-full bg-pink-600 hover:bg-pink-500 text-white font-bold text-lg py-5 px-8 rounded-2xl shadow-[0_10px_30px_-5px_rgba(236,72,153,0.5)] hover:shadow-[0_15px_40px_-5px_rgba(236,72,153,0.7)] transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-153">
                COMPRAR AHORA
                <ChevronRight size={20} className="transition-transform group-hover:translate-x-1" data-id="element-154" />
              </a>

              <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-zinc-500" data-id="element-155">
                <span className="flex items-center gap-1.5" data-id="element-156">
                  <ShieldCheck size={14} className="text-pink-500" data-id="element-157" /> Pago 100%
                  seguro
                </span>
                <span className="flex items-center gap-1.5" data-id="element-158">
                  <Zap size={14} className="text-pink-500" data-id="element-159" /> Acceso inmediato
                </span>
                <span className="flex items-center gap-1.5" data-id="element-160">
                  <FileText size={14} className="text-pink-500" data-id="element-161" /> Formato PDF
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </section>

      {/* FAQ (below final offer) */}
      <section className="py-20 px-4 max-w-3xl mx-auto" data-id="element-162">
        <motion.h2 initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-163">
          Preguntas Frecuentes
        </motion.h2>

        <Accordion items={[{
        title: '¿Y si soy principiante?',
        content: '¡Es ideal para vos! Vas a aprender la técnica correcta desde el principio, evitando vicios que después son muy difíciles de corregir.'
      }, {
        title: '¿Sirve si ya entreno hace años?',
        content: 'Totalmente. El manual aborda desde la base hasta tácticas avanzadas y mentalidad de alto rendimiento para romper estancamientos.'
      }, {
        title: '¿Cómo lo recibo?',
        content: 'Al realizar el pago, recibís acceso inmediato al PDF y todos los bonos directamente en tu mail. Podés descargarlo al instante.'
      }, {
        title: '¿Es un libro físico o digital?',
        content: 'Es un producto 100% digital en formato PDF. Esto nos permite darte acceso inmediato y que puedas llevarlo a todos tus entrenamientos en el celu.'
      }, {
        title: '¿Y si no me funciona?',
        content: 'El manual está diseñado con ejercicios prácticos probados. Si aplicás el paso a paso, vas a ver resultados en tu juego y en tu confianza sí o sí.'
      }]} data-id="element-164" />
      </section>

      {/* FOOTER */}
      <footer className="py-8 text-center text-zinc-600 text-sm border-t border-zinc-900" data-id="element-165">
        <p data-id="element-166">
          © {new Date().getFullYear()} Hockey para Zurdas. Todos los derechos
          reservados.
        </p>
        <p className="mt-2 text-xs" data-id="element-167">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}
// Helper Components
function Badge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-2 bg-zinc-900 border border-zinc-800 px-4 py-2 rounded-full text-sm font-medium text-zinc-300 hover:border-pink-500/50 transition-colors" data-id="element-168">
      <span className="text-pink-500" data-id="element-169">{icon}</span>
      {text}
    </div>;
}
function BonoTitle({
  image,
  text
}: {
  image: string;
  text: string;
}) {
  return <div className="w-full" data-id="element-170">
      <div className="relative w-full h-32 md:h-40 rounded-xl overflow-hidden mb-3 border border-zinc-800" data-id="element-171">
        <img src={image} alt={text} className="w-full h-full object-cover object-top" data-id="element-172" />
        {/* degrade / preview fade */}
        <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-zinc-900/40 to-transparent" data-id="element-173"></div>
        <span className="absolute top-2 left-2 inline-flex items-center gap-1 bg-pink-600 text-white text-[10px] font-bold px-2 py-1 rounded-full uppercase tracking-wider" data-id="element-174">
          <Gift size={11} data-id="element-175" /> Preview
        </span>
      </div>
      <span className="block text-pink-400 font-bold" data-id="element-176">{text}</span>
    </div>;
}
function BulletList({
  items
}: {
  items: string[];
}) {
  return <ul className="space-y-3" data-id="element-177">
      {items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-178">
          <Check size={18} className="text-pink-500 flex-shrink-0 mt-0.5" data-id="element-179" />
          <span data-id="element-180">{item}</span>
        </li>)}
    </ul>;
}
function SummaryItem({
  icon,
  text
}: {
  icon: string;
  text: string;
}) {
  return <li className="flex items-start gap-3 text-zinc-300 font-medium" data-id="element-181">
      <span className="flex-shrink-0 text-xl" data-id="element-182">{icon}</span>
      <span className="mt-0.5" data-id="element-183">{text}</span>
    </li>;
}
function CTAButton({
  children,
  onClick
}: {
  children: React.ReactNode;
  onClick: () => void;
}) {
  return <button onClick={onClick} className="bg-pink-600 hover:bg-pink-500 text-white font-bold text-lg py-4 px-8 rounded-xl shadow-[0_0_20px_rgba(236,72,153,0.3)] hover:shadow-[0_0_30px_rgba(236,72,153,0.5)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 mx-auto w-full md:w-auto" data-id="element-184">
      {children} <ChevronRight size={20} data-id="element-185" />
    </button>;
}